import {mobileVhFix} from './utils/mobile-vh-fix';
import {initAccordion} from './modules/accordion/init-accordion';
import {initCustomSelect} from './modules/custom-select/init-custom-select';
import {initHeader} from './modules/header/init-header';
import {initModals} from './modules/modal/init-modals';
import {initPhoneMask} from './modules/init-phone-mask';
import {initTabs} from './modules/tabs/init-tabs';
import {initValidation} from './modules/wordpress/validation/init-validation';
// import {initCookie} from './modules/cookie/init-cookie';
import {initHamburger} from './modules/init-hamburger';
import {initImpressionsSlider} from './modules/sliders/init-impressions-slider';
import {initMomentsSlider} from './modules/sliders/init-moments-slider';
import {initPromoSlider} from './modules/sliders/init-promo-slider';
import {initAnimations} from './modules/init-animations';
import {initSuitSlider} from './modules/sliders/init-suit-slider';
import {initLimitButtonLength} from './modules/init-limit-button-length';
import {cookieBannerHandler} from './modules/cookie-banner-handler';
import {initSetBookingType} from './modules/init-set-booking-type';
import {initPostsPagination} from './modules/init-posts-pagination';


window.addEventListener('DOMContentLoaded', () => {
  // Utils
  // ---------------------------------

  mobileVhFix();

  // Modules
  // ---------------------------------

  initHeader();
  initModals();
  initAccordion();
  initTabs();
  initCustomSelect();
  initPhoneMask();
  initValidation();
  initSetBookingType();
  // initCookie();
  cookieBannerHandler();
  initHamburger();
  initImpressionsSlider();
  initMomentsSlider();
  initPromoSlider();
  initSuitSlider();
  initLimitButtonLength();
  initPostsPagination();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initAnimations();
  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
